module.exports = __webpack_public_path__ + "static/paprica-4-f17dc7db9163c9b0e9bc6ca5d661f6dc.png";